export const DealMemo = ({ deal, downloadAttachment }) => (
  <div className="paper-surface p-8 md:p-12" data-testid="deal-memo">
    <div className="flex items-center justify-between">
      <span className="wordmark text-sm" style={{ color: "var(--ink-on-paper)" }}>Solera</span>
      <span className="t-label-paper">memo {deal.memo_code}</span>
    </div>
    <div className="hairline-paper mt-6 pt-8">
      <h1 className="text-4xl" style={{ fontWeight: 500 }}>{deal.company}</h1>
      <p className="t-small muted-p mt-2">
        {deal.round_label}. Memo {deal.memo_code}. As at 1 June 2026.
      </p>
    </div>

    <div className="mt-10 space-y-8 measure">
      <section>
        <h2 className="t-h2">The company and its round history</h2>
        <p className="t-body mt-2">{deal.company_history}</p>
      </section>
      <section>
        <h2 className="t-h2">Price against the last round and observable marks</h2>
        <p className="t-body mt-2">{deal.price_context}</p>
      </section>
      <section>
        <h2 className="t-h2">Who is selling and why</h2>
        <p className="t-body mt-2">{deal.seller}</p>
      </section>
      <section>
        <h2 className="t-h2">Path to liquidity</h2>
        <p className="t-body mt-2">{deal.path_to_liquidity}</p>
      </section>
      <section data-testid="memo-unknowns">
        <h2 className="t-h2">What we do not know</h2>
        <ul className="mt-2 space-y-2">
          {deal.unknowns.map((u, i) => (
            <li key={`${i}-${u.slice(0, 24)}`} className="t-body hairline-paper pt-2 first:border-t-0 first:pt-0">{u}</li>
          ))}
        </ul>
      </section>
      {deal.attachments?.length > 0 && (
        <section data-testid="deal-attachments">
          <h2 className="t-h2">Materials</h2>
          <ul className="mt-2 space-y-2">
            {deal.attachments.map((a) => (
              <li key={a.document_id} className="flex justify-between gap-6 items-baseline hairline-paper pt-2 first:border-t-0 first:pt-0">
                <span className="t-body">{a.title}</span>
                <button onClick={() => downloadAttachment(a)} className="t-label-paper underline underline-offset-4"
                  data-testid={`attachment-download-${a.document_id}`}>Download</button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>

    <p className="t-cap muted-p mt-12 hairline-paper pt-4">
      Confidential. This link is issued to one member and is not transferable. Circulation
      outside the membership is a breach of the member agreement. Figures marked as
      reported are unconfirmed. Nothing in this memo is investment advice. All companies
      fictional.
    </p>
  </div>
);
